import "../styles/hero.css";
import { Link } from "react-router-dom";
import { useState } from "react";

import slide1 from "../assets/images/a7.jpg";
import slide2 from "../assets/images/a5.avif";
import slide3 from "../assets/images/a8.webp";
import slide4 from "../assets/images/a9.png";
import slide5 from "../assets/images/a6.webp";

import signiaLogo from "../assets/icons/logo1.webp";
import hansatonLogo from "../assets/icons/logo2.png";
import gnLogo from "../assets/icons/logo3.webp";
import widexLogo from "../assets/icons/logo4.png";
import phonakLogo from "../assets/icons/logo5.webp";

function Hero() {

  const cards = [
    {
      image: slide1,
      logo: signiaLogo,
      title: "Signia",
    },
    {
      image: slide2,
      logo: hansatonLogo,
      title: "Hansaton",
    },
    {
      image: slide3,
      logo: gnLogo,
      title: "GN Resound",
    },
    {
      image: slide4,
      logo: widexLogo,
      title: "Widex",
    },
    {
      image: slide5,
      logo: phonakLogo,
      title: "Phonak",
    },
  ];

  const [active, setActive] = useState(2);

  return (
    <section className="hero">

      <div className="hero-container">

        {/* LEFT */}

        <div className="hero-left">

          <span className="hero-tag">
            Trusted Hearing Care
          </span>

          <h1>
            Hear Better,
            <br />
            Live Better.
          </h1>

          <p>
            Jagadish Hearing Aids has been helping people reconnect with the
            sounds of life for over 35+ years through advanced hearing
            technology, expert audiologists and personalized care.
          </p>

          <div className="hero-buttons">

            <Link to="/services" className="btn-outline">
              <b>Explore Services</b>
            </Link>

          </div>

          <div className="hero-stats">

            <div>
              <h2>35+</h2>
              <p>Years Experience</p>
            </div>

            <div>
              <h2>10000+</h2>
              <p>Happy Clients</p>
            </div>

            <div>
              <h2>100%</h2>
              <p>Personalized Care</p>
            </div>

          </div>

        </div>

        {/* RIGHT */}

        <div className="hero-right" data-aos="zoom-in">

          <div className="gallery">

            {cards.map((card, index) => (

              <div
                key={index}
                className={`gallery-card ${active === index ? "active" : ""
                  }`}
                onClick={() => setActive(index)}
              >

                {/* Image */}

                <img
                  src={card.image}
                  alt={card.title}
                  className="gallery-image"
                />

                {/* Overlay */}

                <div className="gallery-overlay">

                  <div className="gallery-icon">
                    <img
                      src={card.logo}
                      alt={card.title}
                      className="gallery-logo"
                    />
                  </div>

                  {active === index && (

                    <div className="gallery-text">

                      <h3>{card.title}</h3>

                      <p>{card.subtitle}</p>

                    </div>

                  )}

                </div>

              </div>

            ))}

          </div>

        </div>

      </div>

    </section>
  );
}

export default Hero;